import React from 'react';
import PropTypes from 'prop-types';

/**
 * ContactSellerButton component
 * Handles initiating phone calls to listing authors with proper country code formatting
 */
const ContactSellerButton = ({ ensuredAuthor, contactOwnerIcon, css }) => {
  // Country name to country calling code mapping
  const countryCodeMap = {
    'United-Kingdom': '44',
    'Albania': '355',
    'Andorra': '376',
    'Argentina': '54',
    'Australia': '61',
    'Austria': '43',
    'Bahrain': '973',
    'Belgium': '32',
    'Brazil': '55',
    'Brunei': '673',
    'Bulgaria': '359',
    'Canada': '1',
    'Croatia': '385',
    'Cyprus': '357',
    'Czechia': '420',
    'Czech-Republic': '420',
    'Denmark': '45',
    'Egypt': '20',
    'Estonia': '372',
    'Finland': '358',
    'France': '33',
    'Germany': '49',
    'Gibraltar': '350',
    'Greece': '30',
    'Guernsey': '44',
    'Hong-Kong-SAR-China': '852',
    'Hong-Kong': '852',
    'Hungary': '36',
    'Ireland': '353',
    'Isle-of-Man': '44',
    'Italy': '39',
    'Japan': '81',
    'Jersey': '44',
    'Kuwait': '965',
    'Latvia': '371',
    'Lithuania': '370',
    'Luxembourg': '352',
    'Malaysia': '60',
    'Malta': '356',
    'Monaco': '377',
    'Montenegro': '382',
    'Namibia': '264',
    'Netherlands': '31',
    'New-Zealand': '64',
    'North-Macedonia': '389',
    'Norway': '47',
    'Peru': '51',
    'Poland': '48',
    'Portugal': '351',
    'Romania': '40',
    'Serbia': '381',
    'Singapore': '65',
    'Slovakia': '421',
    'Slovenia': '386',
    'South-Africa': '27',
    'Spain': '34',
    'Sweden': '46',
    'Switzerland': '41',
    'Syria': '963',
    'Turkey': '90',
    'Ukraine': '380',
    'United-Arab-Emirates': '971',
    'United-States': '1',
    'Uruguay': '598',
    // Additional countries
    'Bosnia-and-Herzegovina': '387',
    'China': '86',
    'Chile': '56',
    'Colombia': '57',
    'Iceland': '354',
    'India': '91',
    'Indonesia': '62',
    'Israel': '972',
    'Jordan': '962',
    'Kenya': '254',
    'Lebanon': '961',
    'Mexico': '52',
    'Morocco': '212',
    'Nigeria': '234',
    'Oman': '968',
    'Pakistan': '92',
    'Philippines': '63',
    'Qatar': '974',
    'Russia': '7',
    'Saudi-Arabia': '966',
    'South-Korea': '82',
    'Sri-Lanka': '94',
    'Taiwan': '886',
    'Thailand': '66',
    'Tunisia': '216',
    'Venezuela': '58',
    'Vietnam': '84',
    'Algeria': '213',
    'Bangladesh': '880',
    'Nepal': '977',
  };

  const handleContactClick = () => {
    const phoneNumber = ensuredAuthor?.attributes?.profile?.publicData?.phone_number;
    const countryName = ensuredAuthor?.attributes?.profile?.publicData?.country_bio || '';

    if (phoneNumber) {
      // Convert to string and remove any commas (from number formatting)
      const phoneStr = String(phoneNumber).replace(/,/g, '');

      // Get country code from country name
      const countryCode = countryCodeMap[countryName] || '';

      // Construct the full phone number with country code
      let fullNumber = phoneStr;

      // If country code exists and phone doesn't already start with +
      if (countryCode && !phoneStr.startsWith('+')) {
        fullNumber = `+${countryCode}${phoneStr}`;
      } else if (!phoneStr.startsWith('+') && !phoneStr.startsWith('0')) {
        // If no country code but number doesn't start with + or 0, assume it might need one
        fullNumber = `+${phoneStr}`;
      }

      // Remove any spaces, dashes, or parentheses for the tel: link
      const cleanNumber = fullNumber.replace(/[\s\-()]/g, '');

      // Open phone call
      window.location.href = `tel:${cleanNumber}`;
    } else {
      alert('Phone number not available');
    }
  };

  const phoneNumber = ensuredAuthor?.attributes?.profile?.publicData?.phone_number;
  const isDisabled = !phoneNumber;

  return (
    <button
      className={css.contactSellerButton}
      onClick={handleContactClick}
      disabled={isDisabled}
    >
      <img src={contactOwnerIcon} alt="Contact" className={css.buttonIcon} />
      <span>Contact Seller</span>
    </button>
  );
};

ContactSellerButton.propTypes = {
  ensuredAuthor: PropTypes.object.isRequired,
  contactOwnerIcon: PropTypes.string.isRequired,
  css: PropTypes.object.isRequired,
};

export default ContactSellerButton;
